export default "__VITE_ASSET__DBqJGyQ4__"